import { Outlet, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TrainingsTraining, TrainingsTrainingClass } from 'generated/resources/graphql'

export default function Detail() {
  const { classes, canEdit, training } = useOutletContext<{
    training: TrainingsTraining
    classes: TrainingsTrainingClass[]
    canEdit: boolean
  }>()

  return (
    <Box>
      <Outlet context={{ classes, canEdit, training }} />
    </Box>
  )
}
